import { useAuthContext } from "@/context/authentication/auth-context"
import { cn } from "@/lib/class-control"
import { SectionCard } from "@/components/ui/section-card"
import { IProject } from "@/interfaces/project.interface"

interface InfoItemProps {
  label: string
  value: string
  width?: string
}

function InfoItem({ label, value, width = "auto" }: InfoItemProps) {
  return (
    <div className={cn("min-w-0 flex flex-col gap-0.5", width)}>
      <p className="text-xs text-[#d1d1d1] font-normal">{label}</p>
      <p className="text-sm text-white font-bold truncate">{value}</p>
    </div>
  )
}

export function CartaoIdentificacaoProjeto({ projeto }: { projeto: IProject | null }) {
  const { person } = useAuthContext()
  
  const bancoPessoaJuridica = person?.bank_accounts.find(account => account.is_juridic);

  return (
    <SectionCard className="p-4">
      <h2 className="text-xl text-white font-bold mb-5">Identificação do Projeto</h2>
      <div className="flex items-start gap-20">
        <InfoItem label="Título" value={projeto?.name || "Nome do Projeto"} width="w-[187px]" />
        <InfoItem label="Salic" value={projeto?.salic_number || "0000000-000"} width="w-[191px]" />
        <InfoItem label="Proponente" value={person?.juridic_person?.company_name || "Nome de Proponente"} width="w-[223px]" />
        <div className="flex items-start gap-5">
          <InfoItem
            label="Banco"
            value={bancoPessoaJuridica?.bank_name || "Nome do Banco"}
            width="w-[166px]"
          />
          <InfoItem
            label="Agência"
            value={bancoPessoaJuridica?.agency?.toString() || "0000"}
            width="w-[105px]"
          />
          <InfoItem
            label="Conta"
            value={bancoPessoaJuridica?.bank_account || "00000-0"}
            width="w-[104px]"
          />
        </div>
      </div>
    </SectionCard>
  )
}
